import { Image } from '../../../../components/Image/Image';
import styles from './Benefits.module.scss';
export const Benefits = ({content})=>{
  if(!content) return;
  const {title,blocks} = content;
return (
  <>
    {title && <div className={styles.title}>{title}</div>}
    <div className={styles.blocks}>
      {blocks.map((block,i)=>{
        const {title:boxTitle,image,text} = block;
        return (
          <div className={styles.box} key={i}>
            {image && <Image className={styles.boxImage} src={image}/>}
            {boxTitle && <div className={styles.boxTitle}>{boxTitle}</div>}
            {text && <div className={styles.boxText}>{text}</div> }
          </div>
        )
      })}
    </div>
  </>
)
}